export default {
  filename: '',
  type: 'required|min:1|max:255',
  description: 'required|min:1|max:255'
}
